import { render, staticRenderFns } from "./ArticleContainer.vue?vue&type=template&id=682824e0&"
import script from "./ArticleContainer.vue?vue&type=script&lang=js&"
export * from "./ArticleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports